module.exports = __webpack_public_path__ + "img/button.cedb3084.png";